import {h, Fragment} from "preact"
import { translatedText } from "./utils/translatedText";

export default function ProductBadge({
  product,
  hide_sale_badge = false,
  hide_custom_badge = false,
  hide_custom_tag = false,
  hide_other_tags = false,
}) {
  const tags = product.tags1 || [];

  const price = parseFloat(product.price || 0);
  const listPrice = parseFloat(product.listPrice || 0);
  const sale = ((price + 0.01) / (listPrice + 0.01)) * 100;
  const saleRounded = Math.round(100 - sale);

  // --- First matches ---
  const firstStatusTag = !hide_other_tags
    ? tags.find((tag) =>
        ["_coming soon", "out of stock", "_members only"].includes(
          String(tag).toLowerCase()
        )
      )
    : null;

  const firstCustomBadge = !hide_custom_badge
    ? tags.find((tag) => String(tag).toLowerCase().includes("custombadge"))
    : null;

  const firstCustomTag = !hide_custom_tag
    ? tags.find((tag) => String(tag).toLowerCase().includes("customtag"))
    : null;

  return (
    <>
      {/* Sale Badge */}
      {!hide_sale_badge && listPrice > price && saleRounded > 0 ? (
        <span className="inline-block items-center text-13-115--0.5-400 capitalize">
          {`-${saleRounded}%`}
        </span>
      ) : null}

      {/* Status tag (first match only) */}
      {firstStatusTag ? (
        <span className="inline-block items-center text-13-115--0.5-400 capitalize">
          {firstStatusTag.startsWith("_")
            ? firstStatusTag.substring(1)
            : firstStatusTag}
        </span>
      ) : null}

      {/* Custom badge (first match only) */}
      {firstCustomBadge ? (
        <span className="inline-block items-center text-13-115--0.5-400 capitalize">
          {(() => {
            let text = firstCustomBadge.replace(/custombadge_/i, "");
            if (text.startsWith("_")) text = text.substring(1);
            return text;
          })()}
        </span>
      ) : null}

      {/* Custom tag (first match only) */}
      {firstCustomTag ? (
        <span className="inline-block items-center text-13-115--0.5-400 capitalize">
          {(() => {
            let text = firstCustomTag.replace(/customtag_/i, "");
            if (text.startsWith("_")) text = text.substring(1);
            return text;
          })()}
        </span>
      ) : null}
    </>
  );
}

// import { translatedText } from "./utils/translatedText";

// export default function ProductBadge({
//   product,
//   hide_sale_badge = false,
//   hide_custom_badge = false,
// }) {
//   const tags = product.tags1 || [];
//   const badges = [];

//   // --- Sale badge ---
//   const price = parseFloat(product.price || 0);
//   const listPrice = parseFloat(product.listPrice || 0);

//   if (!hide_sale_badge) {
//       badges.push(
//         <span
//           key={`sale-${50}`}
//           className="relative inline-block items-center text-13-115--0.5-400 capitalize"
//         >
//           {`-${50}%`}
//         </span>
//       );
//   }

//   // --- Tag-based badges ---
//   if (!hide_custom_badge) {
//     for (const tag of tags) {
//       const tagLower = String(tag).toLowerCase();

//       // Coming Soon / Out of Stock / Members Only
//       if (["_coming soon", "out of stock", "_members only"].includes(tagLower)) {
//         const text = tag.startsWith("_") ? tag.substring(1) : tag;
//         badges.push(
//           <span
//             key={`status-${tagLower}`}
//             className="relative inline-block items-center text-13-115--0.5-400 capitalize"
//           >
//             {text}
//           </span>
//         );
//         continue;
//       }

//       // Custom Badge
//       if (tagLower.includes("custombadge")) {
//         let text = tag.replace(/custombadge_/i, "");
//         console.log({tag,text})
//         if (text.startsWith("_")) text = text.substring(1); 
//         badges.push(
//           <span
//             key={`custom-${text.toLowerCase()}`}
//             className="relative inline-block items-center text-13-115--0.5-400 capitalize"
//           >
//             {text}
//           </span>
//         );
//       }
//     }
//   }

//   return <>{badges}</>;
// }


// import { translatedText } from "./utils/translatedText";

// export default function ProductBadge({
//   product,
//   hide_sale_badge = false,
//   hide_custom_badge = false,
// }) {
//   let badge = null;
//   const tags = product.tags1 || [];

//   // Parse numbers safely
//   const price = parseFloat(product.price || 0);
//   const listPrice = parseFloat(product.listPrice || 0);

//   // Sale Badge
//   // if (!hide_sale_badge && listPrice > price) {
//   //   const sale = ((price + 0.01) / (listPrice + 0.01)) * 100;
//   //   const saleRounded = Math.round(100 - sale);
//   //   if (saleRounded > 0) {
//   //     badge = (
//   //       <span className="relative inline-block items-center text-13-115--0.5-400 z-10 capitalize">
//   //         {`-${saleRounded}%`}
//   //       </span>
//   //     );
//   //   }
//   // }
//   if (!hide_sale_badge) {


//       badge = (
//         <span className="relative inline-block items-center text-13-115--0.5-400 z-10 capitalize">
//           {`-${50}%`}
//         </span>
//       );

//   }

//   if (!hide_custom_badge) {
//     for (const tag of tags) {
//       const tagLower = tag.toLowerCase();

//       // Coming Soon / Out of Stock / Members Only
//       if (["_coming soon", "out of stock", "_members only"].includes(tagLower)) {
//         const text = tag.startsWith("_") ? tag.substring(1) : tag;
//         badge = (
//           <span className="relative inline-block items-center text-13-115--0.5-400 z-10 capitalize">
//             {text}
//           </span>
//         );
//         break;
//       }

//       // Custom Badge
//       if (tagLower.includes("custombadge")) {
//         let text = tag.replace(/custombadge_/i, "");
//         if (text.startsWith("_")) {
//           text = text.substring(1);
//         }
//         badge = (
//           <span className="relative inline-block items-center text-13-115--0.5-400 z-10 capitalize">
//             {text}
//           </span>
//         );
//         break;
//       }
//     }
//   }

//   return badge;
// }
